export default __webpack_public_path__ + "static/media/person-laptop.5fa028cc.svg";